export const SUPER_ADMIN = 'WMS.SuperAdmin'
export const ADMIN = 'WMS.Admin'
export const PICKER = 'WMS.Picker'
export const WAREHOUSE_SUPERVISOR = 'WMS.WarehouseSupervisor'
export const SUPPORT = 'WMS.Support'
export const DISPATCHER = 'WMS.Dispatch'
export const PUTAWAY = 'WMS.PutAway'
export const ADMUSER = 'WMS.AdmUser'
export const ADMIN_CONFIGURATOR = 'WMS.AdminConfiguration'

export const ALL_PICKER = [PICKER]
export const ALL_WAREHOUSE_SUP = [
  SUPER_ADMIN,
  ADMIN,
  WAREHOUSE_SUPERVISOR,
  SUPPORT
]
export const ALL_ADMIN = [SUPER_ADMIN, ADMIN]
export const ALL_DISPATCH = [SUPER_ADMIN, ADMIN, DISPATCHER]
export const ALL_PUTAWAY = [SUPER_ADMIN, ADMIN, PUTAWAY]
export const ALL_ADMUSER = [ADMUSER]
